export default __webpack_public_path__ + "static/logo-1b5d930ac6affd8d1ff6d3897bef0717.svg";